import Auth from '../Auth'
import 'whatwg-fetch'

const BASE_URL = process.env.config.BACKEND_URL
const API_URL = BASE_URL + '/-'

function ApiConnectionException (statusCode, payload) {
  this.statusCode = statusCode
  this.name = 'ApiConnectionException'
  this.payload = payload
}

function escortToDashboard (exception) {
  if (exception.payload && exception.payload.message) {
    alert(exception.payload.message)
  } else {
    alert('An unknown error occured.')
  }
  window.location = '/'
}

function escortToLogin (exception) {
  if (!/login/.test(window.location)) {
    window.location = '/login'
  } else {
    return exception
  }
}

function createUrl (endpoint) {
  let paramsPosition = endpoint.indexOf('?')
  let params = ''
  if (paramsPosition > -1) {
    params = endpoint.slice(paramsPosition)
  }
  endpoint = endpoint.replace(params, '')
  endpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  endpoint = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint
  return `${API_URL}/${endpoint}/${params}`
}

async function validateResponse (response, onApiConnectionError) {
  const validResponseCodes = [200, 201, 204]
  if (validResponseCodes.indexOf(response.status) === -1) {
    const payload = response.status >= 500 ? {error: 'Internal Server Error'} : await response.json()

    const exception = new ApiConnectionException(response.status, payload)

    if (exception.statusCode === 401) {
      escortToLogin(exception)
    }

    if (onApiConnectionError) {
      onApiConnectionError(exception)
    } else {
      throw exception
    }
  }

  if (response.status !== 204) {
    return await response.json()
  }
  return true
}

async function perform (endpoint, onApiConnectionError, method, payload, additionalHeaders) {
  let headers = new Headers({ 'Content-Type': 'application/json' })

  if (additionalHeaders) {
    Object.keys(additionalHeaders).map(header => {
      headers.set(header, additionalHeaders[header])
    })
  }

  if (Auth.isUserAuthenticated) {
    headers.set('Authorization', `Bearer ${Auth.getToken()}`)
  }

  let options = {
    credentials: 'include',
    method: method || 'GET',
    headers
  }

  if (payload) {
    if (/multipart/.test(headers.get('content-type'))) {
      headers.delete('content-type')
      let formBody = new FormData()

      Object.keys(payload).map(el => {
        formBody.append(el, payload[el])
      })

      options.body = formBody
    } else {
      options.body = JSON.stringify(payload)
    }
  }

  return validateResponse(await fetch(createUrl(endpoint), options), onApiConnectionError)
}

async function get (endpoint, onApiConnectionError) {
  return await perform(endpoint, onApiConnectionError)
}

async function del (endpoint, onApiConnectionError) {
  return await perform(endpoint, onApiConnectionError, 'DELETE')
}

async function patch (endpoint, payload, additionalHeaders, onApiConnectionError) {
  return await perform(endpoint, onApiConnectionError, 'PATCH', payload, additionalHeaders)
}

async function post (endpoint, payload, additionalHeaders, onApiConnectionError) {
  return await perform(endpoint, onApiConnectionError, 'POST', payload, additionalHeaders)
}

export { get, post, patch, del, ApiConnectionException, escortToDashboard }


// WEBPACK FOOTER //
// ./src/modules/API/API.js